import { MAJOR_TONICS } from '@tunasong/music-lib'
import type { NoteName, Scale } from '@tunasong/schemas'

/**
 * Reharm Lab v1 is major-only. The default key matches the existing
 * `DEFAULT_KEY` in `reharm-lab.tsx`.
 *
 * Spec: docs/superpowers/specs/2026-05-20-tool-interlinking-design.md §6
 */
export const DEFAULT_REHARM_KEY: Scale = { root: 'C', type: 'major' }

/**
 * Parse the `?key=` URL param against `MAJOR_TONICS`. Returns a full Scale
 * (type always `'major'`). Silently falls back to `DEFAULT_REHARM_KEY` on
 * any unknown value or spelling not in `MAJOR_TONICS` (e.g., `C#` falls
 * back since the canonical spelling is `Db`).
 *
 * Spec: docs/superpowers/specs/2026-05-20-tool-interlinking-design.md §8.2
 */
export const parseKeyParam = (raw: string | null): Scale => {
  if (raw === null || raw === '') {
    return DEFAULT_REHARM_KEY
  }
  if (!(MAJOR_TONICS as readonly NoteName[]).includes(raw as NoteName)) {
    return DEFAULT_REHARM_KEY
  }
  return { root: raw as NoteName, type: 'major' }
}
